// reducer.js
import * as constants from './constants';
import { ManagementForm } from 'ui/interface/management-form.interface';

// Define proper types for our state
interface Form {
  [formKey: string]: ManagementForm | null; // Or more specific type for your form fields
}

interface LoadingState {
  [formKey: string]: boolean;
}

interface ErrorState {
  [formKey: string]: string | null;
}

interface FormState {
  forms: Form;
  loading: LoadingState;
  errors: ErrorState;
}

const INITIAL_STATE: FormState = {
  forms: {},
  loading: {},
  errors: {},
};

const formFieldsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.FETCH_FORM_START:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.formKey]: true,
        },
        errors: {
          ...state.errors,
          [action.payload.formKey]: null,
        },
      };

    case constants.FETCH_FORM_SUCCESS:
      return {
        ...state,
        forms: {
          ...state.forms,
          [action.payload.formKey]: action.payload.fields,
        },
        loading: {
          ...state.loading,
          [action.payload.formKey]: false,
        },
      };

    case constants.FETCH_FORM_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.formKey]: false,
        },
        errors: {
          ...state.errors,
          [action.payload.formKey]: action.payload.error,
        },
      };

    case constants.CLEAR_FORM: {
      const newForms = { ...state.forms };
      const newLoading = { ...state.loading };
      const newErrors = { ...state.errors };

      delete newForms[action.payload.formKey];
      delete newLoading[action.payload.formKey];
      delete newErrors[action.payload.formKey];

      return {
        ...state,
        forms: newForms,
        loading: newLoading,
        errors: newErrors,
      };
    }

    case constants.CLEAR_ALL_FORMS:
      return {
        ...state,
        forms: {},
        loading: {},
        errors: {},
      };

    default:
      return state;
  }
};

export default formFieldsReducer;
